// =============================================================
// Deep Dive Trips — Site Config (single source of truth)
// Swap these placeholders for real values in one place.
// =============================================================
export const SITE = {
  name: "Deep Dive Trips",
  tagline: "Adventure-first travel across India",
  domain: "https://ddtrips.in",
  description:
    "Adventure-first travel company crafting curated and customizable tour packages for Andaman, Goa, Rajasthan and Leh-Ladakh.",

  // Contact
  whatsappNumber: "919541611626", // digits only, no + or spaces
  enquiryEmail: "hello@ddtrips.in",
  phone: "+91 95416 11626",
  address: "Plot No 69, Avenue 77, Sector 77, Gurgaon, Haryana 122004",
  mapsUrl: "https://maps.app.goo.gl/2T635iU4mHp79mC57",
  mapsEmbedUrl: "https://www.google.com/maps?q=28.389173,76.9785332&z=16&output=embed",
  businessHours: "Mon – Sat, 9:30 AM – 8:00 PM IST",

  // Analytics
  gtmId: "GTM-59WM5VKV",
  ga4Id: "G-HKP591RNLF",
  searchConsoleVerification: "ZOjraRCOOKUEJFjZ4Cx7PCAiwIXsD5KndTUUUxLv0OE",

  // Web3Forms — sends enquiry submissions straight to `enquiryEmail`.
  // Sign up at https://web3forms.com, paste your Access Key below.
  // Leave empty to disable the email send (form will still open WhatsApp).
  web3formsAccessKey: "0d0eed33-8119-4c4f-906f-e64869235212",

  // Socials (placeholders)
  socials: {
    instagram: "https://instagram.com/deepdivetrips",
    facebook: "https://facebook.com/deepdivetrips",
    youtube: "https://youtube.com/@deepdivetrips",
  },
};

export const waLink = (message = "") => {
  const base = `https://wa.me/${SITE.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const waMessageFor = (context = "") => {
  if (!context) return `Hi Deep Dive Trips, I want to plan a trip.`;
  return `Hi Deep Dive Trips, I want to plan a trip to ${context}.`;
};
